import React from "react"
import { Link } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import styled from "styled-components/macro"
import colors from "../../../scripts/colors"
import HomeTagline from "./HomeTagline"
import Button from "../../Button/Button"
// import BulletList from "../../images/list-svgrepo-com.svg"
import Virus from "../../../images/iconmonstr-virus-1.svg"
import CheckCircle from "../../../images/iconmonstr-check-mark-14.svg"
import useFacilityData from "../../../hooks/useFacilityData.ts"
import useCovidConditional from "../../../hooks/useCovidConditional.ts"

const HomeInitCtaStyles = styled.section`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 75px;
  /* height: 300px;
  width: 500px;
  margin-top: -250px;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: 0 6px 14px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(5.5px);
  border: 1px solid rgba(255, 255, 255, 0.2);  */
  @media screen and (min-width: 1500px) {
    flex-wrap: nowrap;
  }
`

const ButtonStyles = styled(Button)`
  margin: 5px 15px -11px 0;
  @media screen and (min-width: 1500px) {
    margin: 5px 0 -11px 15px;
  }
`

const HomeInitCta = () => {
  const pageData = useFacilityData()

  const data = pageData.sanityFacility.facilityObj

  const hasCovidInfo = useCovidConditional()

  return (
    <HomeInitCtaStyles role="region">
      <HomeTagline>{data.siteContent.tagline}</HomeTagline>
      {hasCovidInfo && (
        <ButtonStyles element={Link} icon={<Virus />} to="/covid">
          COVID Resources
        </ButtonStyles>
      )}
      <ButtonStyles
        element={AnchorLink}
        icon={<CheckCircle />}
        to="#HomePage-serviceLinks"
      >
        Services
      </ButtonStyles>
    </HomeInitCtaStyles>
  )
}

export default HomeInitCta
